import React from "react";
import ReactDOM from "react-dom";
import { SortDirection } from "react-virtualized";
import _ from "underscore";
class TableHeader extends React.Component {
  componentDidMount() {
    this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getHeaderMenuItems(this.props.dataKey), this.props.contextMenu.RIGHT_CLICK);
  }
  componentDidUpdate() {
    this.props.contextMenu.removeListener(this._listenerId);
    this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getHeaderMenuItems(this.props.dataKey), this.props.contextMenu.RIGHT_CLICK);
  }
  componentWillUnmount() {
    this.props.contextMenu.removeListener(this._listenerId);
  }
  render() {
    const {
      dataKey,
      label,
      sortBy,
      sortDirection
    } = this.props;
    const isSortable = this.props.isSortable ? this.props.isSortable(label) : false;
    const rowCount = this.props.isFirstColumn(dataKey) ? `(${this.props.rowCount})` : null;
    const sortClasses = {
      sort: isSortable,
      asc: sortBy === label && sortDirection === SortDirection.ASC,
      desc: sortBy === label && sortDirection === SortDirection.DESC,
      any: isSortable && sortBy !== label,
      ReactVirtualized__Table__headerTruncatedText: true,
      sortArrows: true
    };
    const classes = {
      ReactVirtualized__Table__headerTruncatedText: true
    };
    const isLastColumn = this.props.isLastColumn(dataKey);
    const children = [/*#__PURE__*/React.createElement("span", {
      key: "sorter",
      className: _.classSet(sortClasses)
    }), /*#__PURE__*/React.createElement("span", {
      className: _.classSet(classes),
      key: "label",
      title: label
    }, label, " ", rowCount)];
    if (!isLastColumn) {
      children.push(/*#__PURE__*/React.createElement("span", {
        key: "resizeArea",
        "data-key": dataKey,
        className: "resizeArea"
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      style: this.props.columnData ? this.props.columnData.style : null,
      draggable: "true",
      onDragStart: event => this.props.onDragStart(dataKey, event),
      onDrop: event => this.props.onDrop(dataKey, event),
      onDragOver: _.preventDefault
    }, children);
  }
}
export default TableHeader;